import type { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import { MessageOut } from "../../../api/MessageOut.js";

export abstract class PacketOut extends MessageOut {
    public static readonly PACKET_TYPE_KEY = "packet_type";

    public readonly type: OutboundPacketType;

    protected constructor(type: OutboundPacketType) {
        super();
        this.type = type;
    }

    override write(context: MessageIOContext): Record<string, any> {
        return {
            [PacketOut.PACKET_TYPE_KEY]: this.type.getName(),
            ...this.writeContents(context),
        };
    }

    abstract writeContents(context: MessageIOContext): Record<string, any>;
}
